var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{class:[_vm.cssClass, 'autosize'],attrs:{"model":_vm.value,"placeholder":_vm.placeholder,"title":"autosize textarea"},on:{"input":_vm.input}})}
var staticRenderFns = []

export { render, staticRenderFns }